import { styled } from "@mui/material/styles";
import { AppBar, Box, Toolbar } from "@mui/material";

export const NavBar = styled(AppBar)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundImage: "none",
  boxShadow: "none",
  backgroundColor: theme.palette.background.secondary,
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: "60px",
}));

export const InfoContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
});

export const Title = styled("h1")(({ theme }) => ({
  margin: 0,
  fontSize: "1.5rem",
  color: theme.palette.text.primary,
  whiteSpace: "nowrap",
}));

export const AvatarContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  position: "relative",
  "& .dropdown-container": { // Target the sign outdropdown container 
    position: "absolute",
    top: "calc(100% + 8px)",
    right: 0,
    zIndex: 3,
  },
}));

export const NotificationIconContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .MuiIconButton-root": {
    color: theme.palette.text.primary,
  },
  "& .MuiBadge-badge": {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  "& > div": { // Dropdown container
    position: "absolute",
    top: "calc(100% + 8px)",
    right: 0,
    zIndex: 3,
  },
}));